/* eslint-disable */
import React from 'react';
import { injectIntl } from 'react-intl';
import { salaryFormatter } from 'salaryFormatter';
import Icon from '@UI/Icon';
import getJobLocationData from 'getJobLocationData';
import textTransform from 'textTransform';
import { useAppContext } from 'appContext';

function JobItemMetadata({ intl, jobData, config, jobListingsSettings }) {

  const { card_settings } = config
  const { job_card_setting } = jobListingsSettings;
  const fourthOptionIcon = job_card_setting.icon.display;
  const fourthOptionAriaDisplay = job_card_setting.aria_label.display;
  const fourthOptionAriaLabel = fourthOptionAriaDisplay && fourthOptionAriaDisplay.length > 0 ? {"aria-label": job_card_setting.aria_label.display} : {}
  let fourthMetaCardOption = null;
  const { currencySettings: { currencySign } }  = useAppContext();

  const distance = 0;

  jobData.currencySign = currencySign;

  const franceSalaryFormatter = () => {
    if (jobData.Salary.SalaryMin === '0') {
      return '';
    }
    return `${parseFloat(jobData.Salary.SalaryMin).toLocaleString('fr-FR')} ${currencySign} ${jobData.Salary.CompensationType || ''}`;
  };

  const OPCOS_WITHOUT_LOCATION_METADATA = ['sg', 'hk'];
  const location = OPCOS_WITHOUT_LOCATION_METADATA.includes(process.env.REACT_APP_COUNTRY) ? false : process.env.REACT_APP_COUNTRY !== 'fr' ? getJobLocationData(jobData) : `${jobData.JobLocation.City} (${jobData.JobLocation.Postcode.substring(0, 2)})`;
  const salary = process.env.REACT_APP_COUNTRY !== 'fr' ? salaryFormatter(jobData, false, false) : franceSalaryFormatter();

  const renderClientName = () => {
    if (!jobData?.ClientInformation?.ClientName) return;
    return (
      <li className="cards__meta-item">
        <span className="icon icon--inline">
          <Icon svgProps={fourthOptionAriaLabel} type={fourthOptionIcon ? fourthOptionIcon : "building"} />
        </span>
        { textTransform(jobData?.ClientInformation?.ClientName, true) }
      </li>
    )
  }

  const renderWorkHours = () => {
    // France gets the data for the hours meta data field from the Duration field the rest of the opcos are getting it from the Hours field.
    if (process.env.REACT_APP_COUNTRY === "fr" && !jobData?.JobInformation?.Duration) return;
    if (process.env.REACT_APP_COUNTRY !== "fr" && !jobData?.JobInformation?.Hours) return;

    let workHours = process.env.REACT_APP_COUNTRY === "fr" ? intl.formatMessage({id: "JobDetails.Duration.Label"}) + ' ' + jobData.JobInformation.Duration : jobData.JobInformation.Hours;

    return (
      <li className="cards__meta-item">
        <span className="icon icon--inline">
          <Icon svgProps={fourthOptionAriaLabel} type={fourthOptionIcon ? fourthOptionIcon : "clock"} />
        </span>
        { textTransform(workHours, true) }
      </li>
    )
  }

  const renderEducation = () => {
    if (!jobData?.JobInformation?.Education) return;
    return (
      <li className="cards__meta-item">
        <span className="icon icon--inline">
          <Icon svgProps={fourthOptionAriaLabel} type={fourthOptionIcon ? fourthOptionIcon : "education"} />
        </span>
        { textTransform(jobData.JobInformation.Education, true) }
      </li>
    )
  }

  const renderDuration = () => {
    if (!jobData?.JobInformation?.Duration) return;
    return (
      <li className="cards__meta-item">
        <span className="icon icon--inline">
          <Icon svgProps={fourthOptionAriaLabel} type={fourthOptionIcon ? fourthOptionIcon : "calendar"} />
        </span>
        { textTransform(jobData.JobInformation.Duration, true) }
      </li>
    )
  }

  const renderDivision = () => {
    if (!jobData?.BlueXJobData?.CompanyName) return;
    return (
      <li className="cards__meta-item">
        <span className="icon icon--inline">
          <Icon svgProps={fourthOptionAriaLabel} type={fourthOptionIcon ? fourthOptionIcon : "building"} />
        </span>
        { textTransform(jobData.BlueXJobData.CompanyName, true) }
      </li>
    )
  }

  const renderSector = () => {
    if (!jobData?.BlueXJobData?.Specialism) return;
    return (
      <li className="cards__meta-item">
        <span className="icon icon--inline">
          <Icon svgProps={fourthOptionAriaLabel} type={fourthOptionIcon ? fourthOptionIcon : "factory"} />
        </span>
        { textTransform(jobData.BlueXJobData.Specialism, true) }
      </li>
    )
  }

  switch (job_card_setting?.additional_meta_field?.display) {
    case 'client_name_settings':
      fourthMetaCardOption = renderClientName();
      break;
    case 'hours_settings':
      fourthMetaCardOption = renderWorkHours();
      break;
    case 'education_settings':
      fourthMetaCardOption = renderEducation();
      break;
    case 'duration_settings':
      fourthMetaCardOption = renderDuration();
      break;
    case 'division_settings':
      fourthMetaCardOption = renderDivision();
      break;
    case 'sector_settings':
      fourthMetaCardOption = renderSector();
      break;
    default:
      fourthMetaCardOption = null;
  }

  return (
    <ul className="cards__meta">
      {
        process.env.REACT_APP_COUNTRY !== "fr" ? (
          card_settings && card_settings.miles_settings && card_settings.miles_settings.checked ?
            <li className={`cards__meta-item ${distance ? '' : 'hidden'}`}>
            <span className="icon icon--inline">
              <Icon svgProps={card_settings.miles_settings.icon_attributes || {}} type={card_settings.miles_settings.icon ? card_settings.miles_settings.icon : "gps-filled"}/>
            </span>
              {
                distance ?
                  intl.formatMessage({id: "JobItemMetadataMvp1.DistanceAway"}, {distance: distance})
                  : intl.formatMessage({id: "JobItemMetadataMvp1.LessThen"})
              }
            </li> : null
        ) : null
      }
      {
        card_settings && card_settings.location_settings && card_settings.location_settings.checked && location ?
          <li className="cards__meta-item">
            <span className="icon icon--inline">
              <Icon svgProps={card_settings.location_settings.icon_attributes || {}} type={card_settings.location_settings.icon ? card_settings.location_settings.icon : "marker"}/>
            </span>
            { textTransform(location, true) }
          </li> : null
      }
      {
        card_settings && card_settings.jobtype_settings && card_settings.jobtype_settings.checked && jobData.BlueXJobData.JobType ?
          <li className="cards__meta-item">
            <span className="icon icon--inline">
              <Icon svgProps={card_settings.jobtype_settings.icon_attributes || {}} type={card_settings.jobtype_settings.icon ? card_settings.jobtype_settings.icon : "briefcase"}/>
            </span>
            { textTransform(jobData.BlueXJobData.JobType, true) }
          </li> : null
      }
      {
        card_settings && card_settings.salary_settings && card_settings.salary_settings.checked && salary?
          <li className={`cards__meta-item ${jobData.Salary.HideSallary ? 'hidden' : ''}`}>
            <span className="icon icon--inline">
              <Icon svgProps={card_settings.salary_settings.icon_attributes || {}} type={card_settings.salary_settings.icon ? card_settings.salary_settings.icon : "salary"}/>
            </span>
            { salary }
          </li> : null
      }
      {fourthMetaCardOption}
    </ul>
  );
}

export default injectIntl(JobItemMetadata);
